module.exports = __webpack_public_path__ + "img/qitafuwushang_image_zhucan.9be80d52.png";